import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import OrdersApi from '../../../API/shipment/orders-api';
import delete_img from '../../../assets/media/bucket.svg';
import close from '../../../assets/media/icons/close.svg';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, ButtonWithTooltip } from '../../../components/Basic/Buttons';
import { Icon } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { DateInput, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1 } from '../../../components/Basic/WrapsStyle';
import { SHIPMENT_STATUS_TEXT, STATUS_COLORS, TO_ORDER, TYPE_BUTTONS, WAREHOUSE_LIST } from '../../../constans';
import { getDateSolid, setDateSolid } from '../../../utils';
import CreateOrderPopUp from './CreateOrderPopUp';
import DeleteOrderPopUp from './DeletePopUp';
import styles from './styles.module.scss';

const width = ['40px', '140px', '150px', '200px'];

const SKLAD_LIST = [{ warehouse: 'Не выбран', name: undefined }, ...WAREHOUSE_LIST];

const STATUSES = ['Не выбран', 'Отгрузка не начата', 'Отгрузка начата', 'Отгрузка закончена'];

const MAP_SKLAD = {
  msk: 'Москва',
  ekb: 'Екатеринбург',
};

function OrdersPage() {
  const [create, setCreate] = useState(false);
  const [popUpDelete, setDeletePopUp] = useState({ show: false, order: {} });
  const [skladName, setSkladName] = useState(SKLAD_LIST[0]);
  const [tab, setTab] = useState(0);
  const [show, setShow] = useState(50);
  const [date, setDate] = useState(null);

  const [orders, setOrders] = useState([]);
  const user = useSelector((store) => store.user);


  const loadOrders = () => {
    OrdersApi.getOrders({ data: { skladName: skladName.name, limit: parseInt(show), orderDate: date } }).then((r) => setOrders(r.orders))
  };

  const onClickCreate = () => {
    setCreate(true);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const onCloseDelete = () => {
    setDeletePopUp({ show: false, order: {} });
    loadOrders({})
  };


  useEffect(() => {
    loadOrders({});
  }, [tab, show, skladName.name, date]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <H1>Заказы по дням</H1>

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={['Все']}
              // num={count}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
          </Row>
          <Row spaceBetween={true} style={{ marginTop: '25px' }}>
            <Row style={{ height: '40px' }}>
              <Select
                label="Показать на странице"
                select={show}
                list={['10', '20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Город"
                select={skladName}
                list={SKLAD_LIST}
                valueFn={(p) => p.warehouse}
                onSelect={(v) => setSkladName(v)}
                width="200px"
                style={{ marginRight: '15px' }}
              />
              <Column style={{ marginRight: '15px' }}>
                <InputLabel>Дата заказа</InputLabel>
                <Row style={{ position: 'relative', width: '150px' }}>
                  <DateInput value={date} className={styles.calendar} onChange={(v) => setDate(setDateSolid(v))} />
                  <Button className={styles.close_button} onClick={() => setDate(null)}>
                    <img src={close} style={{ width: '15px' }} />
                  </Button>
                </Row>
              </Column>
              {(isOwner || user.role === 'user') && (
                <Button type={TYPE_BUTTONS.GREEN} onClick={onClickCreate}>
                  Создать заказ
                </Button>
              )}
            </Row>
          </Row>
        </WhiteBlock>
        <Table>
          <TableHeader whiteHeader>
            <HeaderTitle width={width[0]}>Id</HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Дата заказа
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Дата отгрузки
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Склад
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Количество заказов
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Статус
            </HeaderTitle>
            <HeaderTitle width={width[3]} centerText>
              Создатель
            </HeaderTitle>
          </TableHeader>
          {(orders || []).map((order) => {
            return (
              <TableLine key={order.id}>
                <TableCell width={width[0]}>{order.id}</TableCell>
                <TableCell width={width[2]} center>
                  <NavLink to={TO_ORDER(order.id)} className={styles.line_table_link}>
                    {moment(getDateSolid(order.dates.scheduled)).format('DD.MM.YYYY')}
                  </NavLink>

                </TableCell>
                <TableCell width={width[2]} >
                  <Column>
                    {order.dates?.shipment?.map((i, index) => (
                      <Row key={index} style={{ fontSize: '12px', justifyContent: 'center' }}>{`${i.shop}-${moment(getDateSolid(i.date)).format('DD.MM.YY')}`}</Row>
                    ))}
                  </Column>
                </TableCell>
                <TableCell width={width[2]} center>
                  {MAP_SKLAD[order.sklad_name]}
                </TableCell>
                <TableCell width={width[2]} center>
                  {order.num_postings}
                </TableCell>
                <TableCell width={width[2]} style={{ color: `${STATUS_COLORS[order.state]}` }} center>
                  {SHIPMENT_STATUS_TEXT[order.state]}
                </TableCell>
                <TableCell width={width[3]} center>
                  {order.creator}
                </TableCell>
                <TableCell styles={styles.delete_cell}>
                  {isOwner && (
                    <ButtonWithTooltip
                      tooltip="Удалить"
                      onClick={() => setDeletePopUp({ show: true, order })}
                      disabled={order.state === 'ended' || order.state === 'started'}
                    >
                      <Icon src={delete_img} width={'20px'} />
                    </ButtonWithTooltip>
                  )}
                </TableCell>
              </TableLine>
            );
          })}
        </Table>
        {orders.length >= 0 && (
          <Button className={styles.show_more} onClick={() => setShow(show + 30)}>
            Посмотреть ещё <span className={styles.arrow_blue} />
          </Button>
        )}
      </Content>

      {create && (
        <CreateOrderPopUp
          close={() => {
            setCreate(false);
            loadOrders({})
          }}
        />
      )}
      {popUpDelete.show && <DeleteOrderPopUp order={popUpDelete.order} close={onCloseDelete} />}
    </>
  );
}

export default OrdersPage;
